(function() {
  function initReviewsBehavior(container) {
    window.toggleReviews = function(btn) {
      const hiddenDiv = container.querySelector('#rv-hidden');
      if (!hiddenDiv) return;
      const isCollapsed = hiddenDiv.classList.contains('is-collapsed');
      if (isCollapsed) {
        hiddenDiv.classList.remove('is-collapsed');
        btn.classList.add('is-open');
        btn.innerHTML = `Ver menos <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
      } else {
        hiddenDiv.classList.add('is-collapsed');
        btn.classList.remove('is-open');
        btn.innerHTML = `Ver más reseñas <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
      }
    };

    window.rvVote = function(btn, val) {
      const isUp = btn.classList.contains('rv-up');
      if (btn.classList.contains('is-on')) {
        btn.classList.remove('is-on');
        updateCount(btn, -val);
      } else {
        const parent = btn.parentElement;
        const sibling = parent.querySelector(isUp ? '.rv-down' : '.rv-up');
        if (sibling && sibling.classList.contains('is-on')) {
          sibling.classList.remove('is-on');
          updateCount(sibling, isUp ? 1 : -1);
        }
        btn.classList.add('is-on');
        updateCount(btn, val);
      }
    };
  }

  function updateCount(btn, diff) {
    const help = btn.closest('.rv-help');
    if (!help) return;
    const countEl = help.querySelector('.rv-count');
    if (!countEl) return;
    const current = parseInt(countEl.textContent, 10) || 0;
    countEl.textContent = Math.max(0, current + diff);
  }

  function loadReviews(container) {
    if (container.getAttribute('data-loaded') === 'true') return;
    const template = container.querySelector('#rv-template');
    if (!template) return;

    const content = template.content.cloneNode(true);
    const loading = container.querySelector('#rv-loading');
    if (loading) loading.remove();

    container.appendChild(content);
    container.setAttribute('data-loaded', 'true');
    initReviewsBehavior(container);
  }

  function setup() {
    const container = document.querySelector('#rv-section');
    if (!container) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadReviews(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '350px 0px 350px 0px' });

    observer.observe(container);

    window.addEventListener('load', () => {
      setTimeout(() => {
        if (container.getAttribute('data-loaded') !== 'true') {
          loadReviews(container);
        }
      }, 3500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
